import { FlagrFlag } from '../common/services/FlagrService/types';
import { FlagDescription } from './Dogfood.styles';

interface Props {
  flag: FlagrFlag;
}

export const FlagRollout = ({ flag }: Props) => (
  <>
    {flag.segments.map((segment, idx) => (
      <>
        <>
          <FlagDescription>
            <i>Segment: </i>
            {segment.description || `Segment ${idx + 1}`}
          </FlagDescription>
          <FlagDescription>
            <i>Segment Rollout: </i>
            {segment.rolloutPercent}%
          </FlagDescription>
        </>
      </>
    ))}
  </>
);
